import { render, staticRenderFns } from "./TradesLog.vue?vue&type=template&id=723a8410&scoped=true&"
import script from "./TradesLog.vue?vue&type=script&lang=ts&"
export * from "./TradesLog.vue?vue&type=script&lang=ts&"
import style0 from "./TradesLog.vue?vue&type=style&index=0&id=723a8410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723a8410",
  null
  
)

export default component.exports